import { Component, OnInit } from '@angular/core';
import { FaqService } from '../shared/services/faq.service';
import {Title } from "@angular/platform-browser";

//jquery declaration
declare var $: any;

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {

  faqDetails: any = [];
  search: string = "";

  constructor(
    private service: FaqService,
    private titleService: Title,
  ) { }

  async ngOnInit(): Promise<void> {
    this.titleService.setTitle("FAQ - SFI Compliance, Inc");
    this.topposition();
    await this.service.getFAQ().then(data => {
      this.faqDetails = data;
    })
  }

  topposition() {

    // if ($('#preloader').length) {
    //   $('#preloader').delay(500).fadeOut('slow', function() {
    //     $(this).remove();
    //   });
    // }
    $('html, body').animate({
      scrollTop: 0
    }, 1000, 'easeInOutExpo');

    return false;
  }

  async searchData(): Promise<void> {
    await this.service.getFAQ().then(data => {
      if (this.search === "") {
        this.faqDetails = data;
      }
      else {
        this.faqDetails = data.filter(x => x.heading.toLowerCase().toString().includes(this.search.toLowerCase()));
        console.log(this.faqDetails);
      }
    })
  }

}
